module.exports = __webpack_public_path__ + "static/love-desktop2-68989ec03c27812612d5b5a4c3311dc3.png";